import React, { FC } from 'react';
import { View, Text, StyleSheet } from 'react-native';
import TouchableElement from '@components/common/touchableElement';
import i18n from 'i18n-js';
import { font as initialFont } from '@styles/fonts';
import { scale as initialScale } from '@components/frame';
import { ColorFunction } from '@styles/colors/types';
import { ScaleFunction } from '@components/operatorPanel/interfaces';
import { SCREEN_BORDER_RADIUS } from '@v2/pages/common/constants/base.constants';

export interface AnimatedTableHeaderProps {
  config: any;
  renderArrow: (orderBy: string, color: string) => React.ReactNode;
  scale?: ScaleFunction;
  C: ColorFunction;
  headerSize: number;
  filterPress: (orderBy: string) => void;
  font?: typeof initialFont;
}

const AnimatedTableHeader: FC<AnimatedTableHeaderProps> = ({
  config,
  renderArrow,
  scale = initialScale,
  C,
  headerSize,
  filterPress,
  font = initialFont,
}) => {
  const headerConfig = typeof config === 'function' ? config({ isSubRow: false }) : config;

  return (
    <View
      style={[
        {
          borderBottomColor: C('Hairline/Light/No trans'),
          alignItems: 'center',
          paddingRight: scale(30),
          paddingLeft: scale(15),
          flexDirection: 'row',
          borderBottomWidth: StyleSheet.hairlineWidth,
          backgroundColor: C('Background / Light / Field'),
          borderTopLeftRadius: scale(SCREEN_BORDER_RADIUS),
          borderTopRightRadius: scale(SCREEN_BORDER_RADIUS),
        },
      ]}
    >
      {headerConfig.map((item, index) => (
        <TouchableElement
          hitSlop={{ top: 0, bottom: 0, left: 0, right: 0 }}
          onPress={() => filterPress(item.orderBy)}
          disabled={!item.sort}
          key={`config-${item.key}-${index}`}
        >
          {({ boxStyle, pressHoverColor }) => (
            <View
              style={[
                {
                  width: item.width,
                  flexDirection: 'row',
                  height: scale(headerSize),
                  alignItems: 'center',
                },
                boxStyle,
              ]}
            >
              <View style={[!item.sort && { flex: 1 }, item?.titleStyle]}>
                {typeof item.title === 'function' ? (
                  item.title(item)
                ) : (
                  <Text
                    numberOfLines={1}
                    style={[
                      {
                        color: item.titleColor,
                        fontWeight: 'normal',
                        fontSize: scale(13),
                      },
                      font['Button 2'],
                    ]}
                  >
                    {Boolean(item.title) && i18n.t(item.title)}
                  </Text>
                )}
                {item.smallTitle && (
                  <Text
                    style={[
                      {
                        color: item.smallTitleColor,
                        fontWeight: 'normal',
                        fontSize: scale(13),
                      },
                      font['Button 2'],
                    ]}
                  >
                    {i18n.t(item.smallTitle)}
                  </Text>
                )}
              </View>
              {item.sort && renderArrow(item.orderBy, item.titleColor)}
            </View>
          )}
        </TouchableElement>
      ))}
    </View>
  );
};

export default AnimatedTableHeader;
